<template>
  <header class="navbar">
    <div class="navbar-inner">
      <div class="navbar-left" @click="goHome">
        <img class="logo-mark" src="@/assets/logo.png" alt="文常商服 Logo">
        <div class="logo-text">
          <div class="logo-title">文常商服</div>
        </div>
      </div>
      <nav class="navbar-right">
        <router-link
          v-for="item in menus"
          :key="item.path"
          :to="item.path"
          exact
          class="nav-item"
          active-class="nav-item--active"
        >
          {{ item.label }}
        </router-link>
      </nav>
      <button class="nav-toggle" @click="toggleMobile">
        <span></span>
        <span></span>
      </button>
    </div>
    <transition name="nav-slide">
      <div v-if="mobileOpen" class="navbar-mobile">
        <router-link
          v-for="item in menus"
          :key="item.path"
          :to="item.path"
          exact
          class="nav-item-mobile"
          active-class="nav-item-mobile--active"
          @click.native="mobileOpen = false"
        >
          {{ item.label }}
        </router-link>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      mobileOpen: false,
      menus: [
        { path: '/', label: '首页' },
        { path: '/insurance', label: '保险信息' },
        { path: '/news', label: '行业资讯' },
        { path: '/service', label: '在线客服' },
        { path: '/contact', label: '联系我们' }
      ]
    }
  },
  methods: {
    goHome() {
      this.$router.push('/')
    },
    toggleMobile() {
      this.mobileOpen = !this.mobileOpen
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(8, 22, 48, 0.98);
  backdrop-filter: blur(10px);
  box-shadow: 0 12px 30px rgba(5, 11, 24, 0.6);
}

.navbar-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
}

.navbar-left {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo-mark {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  object-fit: cover;
  margin-right: 10px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.6);
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.logo-title {
  font-size: 18px;
  color: #ffffff;
}

.logo-subtitle {
  font-size: 11px;
  color: #9fb3c8;
  letter-spacing: 0.04em;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 18px;
}

.nav-item {
  position: relative;
  font-size: 14px;
  color: #cbd2e1;
  padding: 4px 2px;
  transition: color 0.2s ease;
}

.nav-item::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 0;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, #4f8dfd, #39d2c0);
  transition: width 0.25s ease;
}

.nav-item:hover {
  color: #ffffff;
}

.nav-item:hover::after {
  width: 100%;
}

.nav-item--active {
  color: #ffffff;
  font-weight: 500;
}

.nav-item--active::after {
  width: 100%;
}

.nav-toggle {
  display: none;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.6);
  background: transparent;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.nav-toggle span {
  display: block;
  width: 16px;
  height: 2px;
  border-radius: 999px;
  background: #e5e9f0;
  margin: 2px 0;
}

.navbar-mobile {
  display: none;
}

.nav-slide-enter-active,
.nav-slide-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.nav-slide-enter,
.nav-slide-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

@media (max-width: 768px) {
  .navbar-inner {
    padding-inline: 14px;
  }

  .navbar-right {
    display: none;
  }

  .nav-toggle {
    display: inline-flex;
  }

  .navbar-mobile {
    display: flex;
    flex-direction: column;
    padding: 8px 16px 12px;
    background: rgba(8, 22, 48, 0.98);
    border-top: 1px solid rgba(30, 64, 175, 0.6);
  }

  .nav-item-mobile {
    padding: 8px 0;
    font-size: 14px;
    color: #e5e9f0;
    border-bottom: 1px solid rgba(15, 23, 42, 0.6);
  }

  .nav-item-mobile:last-child {
    border-bottom: none;
  }

  .nav-item-mobile--active {
    color: #38bdf8;
  }
}
</style>

